__turbopack_context__.v({
  "card": "RadioListQuestion-module-scss-module__uYjGja__card",
  "grid": "RadioListQuestion-module-scss-module__uYjGja__grid",
  "input": "RadioListQuestion-module-scss-module__uYjGja__input",
});
